import { useRequestState } from "@/hooks";
import { useEffect } from "react";
import { requestNews } from "@/services/api/news/requests";
import { applyMock } from "@/utils";
import { mockNews } from "@/pages/home/mock";
import { AccountInfo } from "@azure/msal-browser";
import { NewsResponse } from "@/services/api";

export const useNewsList = (account: AccountInfo | null | undefined) => {
  const { isLoading, data, error, setInProgress, setSuccess, setError } =
    useRequestState<NewsResponse>({ isLoading: true });

  useEffect(() => {
    const controller = new AbortController();
    setInProgress();

    requestNews(
      {
        email: account?.username ?? "",
      },
      { signal: controller.signal },
    )
      .then(response => setSuccess(response))
      .catch(() => {
        if (+window.APP_CONFIG.FEATURES.IS_MOCK_ENABLED) {
          applyMock(mockNews.News, setSuccess, "requestNews");
        } else {
          setError(error);
        }
      });

    return () => {
      controller.abort();
    };
  }, [account, error, setError, setInProgress, setSuccess]);

  return {
    isLoadingNewsList: isLoading,
    newsList: data,
    errorNewsList: error,
  };
};
